import { CoreDataSecurityApplicationsBulkName } from './name';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityApplicationsAllSlice } from '../all/get';
import { patchDataSecurityApplications } from '@api/data-security/patchDataSecurityApplications';
import { updateApplicationReferences } from '../_idMap/actions';

export const patchCoreDataSecurityApplicationsBulkSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => updateApplicationReferences(
				request.applicationIds.map((applicationId) => ({
					applicationId,
					classification: request.classification,
					ownerId: request.ownerId,
					stakeholderGroupId: request.stakeholderGroupId,
					stakeholderIds: request.stakeholderIds
				}))
			),
			() => getCoreDataSecurityApplicationsAllSlice.asyncActionCreators.repeatGetCoreDataSecurityApplicationsAll()
		]
	},
	name: CoreDataSecurityApplicationsBulkName,
	receive: false,
	request: true,
	requestHandler: patchDataSecurityApplications
});
